module.exports = __webpack_public_path__ + "static/1-9255888bd75be7e7b5ba1b9afb7305c5.png";